import { useCallback } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { useNoticeBannersStackContext } from '@sg/garnish';

export const useNotifyStripeError = (
  trackStripeUsage: (payload: Record<string, unknown>) => void,
) => {
  const { push: addNoticeBanner } = useNoticeBannersStackContext();
  const { formatMessage } = useIntl();
  const errorMessage = formatMessage(messages.error);

  return useCallback(
    (message = errorMessage) => {
      trackStripeUsage({ event: 'stripe_failure', error: message });
      addNoticeBanner({ text: message, palette: 'caution' });
    },
    [errorMessage, trackStripeUsage, addNoticeBanner],
  );
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  error: {
    defaultMessage: 'Something went wrong, try again in a few moments...',
    description: 'Stripe Payment | Unknown Error',
  },
});
